import { getToken } from '@/services/auth'

export default function(to, from, next) {
  if (!getToken()) {
    return next('/login')
  } 

  next()
}